import * as React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { colors } from '../../theme';

/**
 * Thin Apple-style progress bar fixed to the top of the viewport that fills
 * as the user scrolls through the page.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        transformOrigin: '0% 50%',
        scaleX,
        zIndex: 2000,
        background: `linear-gradient(90deg, ${colors.blue}, ${colors.blueDark})`,
      }}
    />
  );
}
